import { Workbox } from 'workbox-window';

let wb: Workbox | null = null;
const listeners = new Set<() => void>();
let waiting = false;

/** Registers the service worker in production builds. Updates wait for the user (never mid-round). */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;
  wb = new Workbox('/sw.js');
  wb.addEventListener('waiting', () => {
    waiting = true;
    for (const l of listeners) l();
  });
  void wb.register();
}

export function onUpdateAvailable(cb: () => void): () => void {
  listeners.add(cb);
  if (waiting) cb();
  return () => listeners.delete(cb);
}

export function applyUpdate(): void {
  if (!wb) return;
  wb.addEventListener('controlling', () => window.location.reload());
  wb.messageSkipWaiting();
}
